var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "30px",
    viewBox: "0 0 41 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_youtube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Winds-Webapp",
    transform: "translate(-386.000000, -8608.000000)",
    fill: "#ADADB2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(0.000000, 8145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(252.000000, 463.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.279786,5.15625 C172.90625,3.09448219 171.126465,1.59301781 169.061036,1.12426781 C165.970215,0.46875 160.25,0 154.061036,0 C147.875732,0 142.063965,0.46875 138.969482,1.12426781 C136.907715,1.59301781 135.124268,2.99926781 134.750732,5.15625 C134.373536,7.5 134,10.78125 134,15 C134,19.21875 134.373536,22.5 134.842286,24.84375 C135.219482,26.9055178 136.999268,28.4069822 139.061036,28.8757322 C142.342286,29.53125 147.967286,30 154.15625,30 C160.345215,30 165.970215,29.53125 169.251465,28.8757322 C171.313232,28.4069822 173.093018,27.0007322 173.470215,24.84375 C173.84375,22.5 174.3125,19.1235356 174.407715,15 C174.217286,10.78125 173.748536,7.5 173.279786,5.15625 Z M149,21.5625 L149,8.4375 L160.436768,15 L149,21.5625 Z",
    id: "ic_youtube"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic_youtube.f83bd8d4b6f67be79d1fb3610c2bf38f.svg";
export { ForwardRef as ReactComponent };